import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const styles = StyleSheet.create({
  footerAbsolute: {
    position: 'absolute',
    bottom: 25,
    left: 35,
    right: 35,
    borderTop: '2px solid #005EB8',
  },

  footerFlex: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 5,
  },

  footerUrl: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    fontFamily: 'Figtree',
    textAlign: 'left',
    color: '#005EB8',
    paddingLeft: 10,
  },

  footerNumberPage: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    fontFamily: 'Figtree',
    textAlign: 'center',
    color: '#005EB8',
    alignItems: 'center',
    justifyContent: 'center',
  },

  footerDate: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    fontFamily: 'Figtree',
    textAlign: 'right',
    color: '#005EB8',
    paddingRight: 10,
  },
})

interface ItineraryReportFooterPdfProps {
  generatedAt?: Date
}

export default function ItineraryReportFooterPdf({
  generatedAt = new Date(),
}: ItineraryReportFooterPdfProps) {
  const formattedDate = format(generatedAt, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })
  const formattedTime = format(generatedAt, 'HH:mm', { locale: ptBR })

  return (
    <View style={styles.footerAbsolute} fixed>
      <View style={styles.footerFlex}>
        <Text style={styles.footerUrl}>www.prixsebrae.com</Text>
        <Text
          style={styles.footerNumberPage}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        />
        <Text style={styles.footerDate}>
          {formattedDate} às {formattedTime}
        </Text>
      </View>
    </View>
  )
}
